document.addEventListener("DOMContentLoaded", function () {
  const textSlider = document.querySelector(
    '[data-component="text-slider"] .swiper'
  );
  const slides = textSlider.querySelectorAll(".swiper-slide");
  const desktopButtons = document.querySelectorAll(
    ".home-product-selector__navigation-desktop button"
  );
  const mobileButtons = document.querySelectorAll(
    ".home-product-selector__navgiation-mobile-wrapper button"
  );
  const productSlider = document.querySelector(
    '[data-component="home-product-selector-desktop-slider"] .swiper'
  );

  if (
    !textSlider ||
    !productSlider ||
    !slides.length ||
    !desktopButtons.length ||
    !mobileButtons.length
  ) {
    return;
  }

  const mobileOrder = [
    "tranquil, softened, floating",
    "energetic, focused, creative",
    "ecstatic, celebratory, connected",
    "passionate, sensual, allured",
    "confident, powerful, grounded",
    "protected, guided, safe",
  ];

  const originalTexts = Array.from(slides).map(
    (slide) => slide.querySelector("p").textContent
  );

  function updateSlideText(isMobile) {
    slides.forEach((slide, index) => {
      const p = slide.querySelector("p");
      p.textContent = isMobile ? mobileOrder[index] : originalTexts[index];
    });
  }

  function handleResize() {
    const isMobile = window.innerWidth < 768; // Adjust breakpoint as needed
    updateSlideText(isMobile);

    // Select the third element by default on mobile
    if (isMobile) {
      updateActiveElements(2);
      if (textSlider.swiper) {
        textSlider.swiper.slideTo(2, 0);
      }
      if (productSlider.swiper) {
        productSlider?.swiper.slideTo(2, 0);
      }
    } else {
      updateActiveElements(0);
      if (textSlider.swiper) {
        textSlider.swiper.slideTo(0, 0);
      }
      if (productSlider.swiper) {
        productSlider.swiper.slideTo(0, 0);
      }
    }
  }

  function updateActiveElements(index) {
    // Update desktop buttons
    desktopButtons.forEach((button, i) => {
      button.classList.toggle("active", i === index);
    });

    // Update mobile buttons
    mobileButtons.forEach((button, i) => {
      button.classList.toggle("active", i === index);
    });

    // Update text slides
    slides.forEach((slide, i) => {
      slide.classList.toggle("swiper-slide-active", i === index);
    });

    // Update product slider
    if (productSlider.swiper) {
      productSlider.swiper.slideTo(index);
    }
  }

  // Handle desktop button clicks
  desktopButtons.forEach((button, index) => {
    button.addEventListener("click", () => updateActiveElements(index));
  });

  // Handle mobile button clicks
  mobileButtons.forEach((button, index) => {
    button.addEventListener("click", () => updateActiveElements(index));
  });

  // Handle text slide hover
  slides.forEach((slide, index) => {
    slide.addEventListener("mouseenter", () => updateActiveElements(index));
  });

  // Initial call to set correct text and active element
  handleResize();

  // Add event listener for window resize
  window.addEventListener("resize", handleResize);
});

/**
 * Fix for Mobile Text Slider Interaction
 *
 * This function solves the issue where text slides weren't properly triggering
 * product slider changes on mobile devices. The problem occurred because:
 *
 * 1. On mobile, touch events weren't properly connecting the text slides with product slides
 * 2. While the "active" class was being added to buttons, the actual product slider wasn't updating
 *
 * The solution creates a direct connection between text slides and product buttons:
 * - Detects mobile devices using media query
 * - Adds click event listeners to each text slide
 * - When a text slide is clicked, it programmatically triggers a click on the
 *   corresponding product button, which already has working slider functionality
 *
 * This approach bypasses any issues with the Swiper API by leveraging the existing
 * button click handlers that were already working correctly.
 */
// Track whether we've already set up the event listeners
let textSlideListenersInitialized = false;

// Function to check device size and initialize if needed
function checkDeviceAndInitialize() {
  const isSmallDevice = window.matchMedia("(max-width: 980px)").matches;

  if (isSmallDevice && !textSlideListenersInitialized) {
    tweakTextSlide();
    textSlideListenersInitialized = true;
    // console.info("Mobile text slide interaction initialized");
  }
}

// Initialize text slide click handlers for mobile
function tweakTextSlide() {
  const textSlides = document.querySelectorAll(
    '[data-component="text-slider"] .swiper-slide'
  );
  const productSlidesBtns = document.querySelectorAll(
    ".home-product-selector__navgiation-mobile-wrapper button"
  );

  // Use correct condition: should be || (or) not && (and)
  if (!textSlides.length || !productSlidesBtns.length) {
    console.warn("Text slides or product buttons not found");
    return;
  }

  textSlides.forEach(function (textSlide, idx) {
    // Remove any existing listeners first to prevent duplicates
    textSlide.removeEventListener("click", handleTextSlideClick);

    // Add click event with named function for easier removal if needed
    textSlide.addEventListener("click", handleTextSlideClick);

    // Also add touch event for better mobile support
    textSlide.addEventListener("touchend", function (e) {
      e.preventDefault(); // Prevent default touch behavior
      handleTextSlideClick(e);
    });

    // Named handler function
    function handleTextSlideClick(event) {
      // Make sure the button exists before trying to click it
      if (productSlidesBtns[idx]) {
        productSlidesBtns[idx].dispatchEvent(new Event("click"));
        // console.log(
        //   `Text slide ${idx} clicked, triggering product button ${idx}`
        // );
      }
    }
  });
}

// Check on initial load
window.addEventListener("DOMContentLoaded", checkDeviceAndInitialize);
window.addEventListener("load", checkDeviceAndInitialize);

// Check on resize with debounce to prevent excessive calls
let resizeTimer;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(checkDeviceAndInitialize, 250);
});
